import { useState } from "react";
import "./partnerBottomButtonsWrap.scss";

import { isExternalUrl } from "@src/utils";

import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";

import WriteReviewImage from "@src/assets/images/partner/review/write-review-icon.png";
import WriteNaverReviewImage from "@src/assets/images/partner/review/write-naver-review-icon.png";

export default function PartnerBottomButtonsWrap(props: {
  // isShowWriteReviewButton: boolean;
  writeReviewPageUrl?: string;
  writeBlogReviewPageUrl?: string;
  buttonName: string;
  buttonType: string;
  buttonUrl?: string;
}) {
  const [isOpenWriteReviewModal, setIsOpenWriteReviewModal] = useState<boolean>(false);

  function openWriteReviewModal() {
    setIsOpenWriteReviewModal(true);
  }

  function closeWriteReviewModal() {
    setIsOpenWriteReviewModal(false);
  }

  function handleClickWriteReviewButton(link?: string) {
    if (link) {
      window.location.href = link;
    }
    closeWriteReviewModal();
  }

  function handleClickRightButton() {
    const buttonUrl = props.buttonUrl;
    if (!buttonUrl) return;

    if (props.buttonType !== "TEL") {
      window.location.href = isExternalUrl(buttonUrl);
    } else {
      window.location.href = buttonUrl;
    }
  }

  return (
    <>
      <div className="partner-bottom-buttons-wrap">
        <div className="inner">
          <div className="background"></div>
          <button onClick={openWriteReviewModal} className="btn btn-giant btn-red0">
            리뷰쓰기
          </button>
          <button onClick={handleClickRightButton} className="btn btn-giant btn-red500">
            {props.buttonName}
          </button>
        </div>
        <div className="ios-safe-area"></div>
      </div>

      {/* 리뷰쓰기 하단 팝업 */}
      <BottomFixedModal
        isShow={isOpenWriteReviewModal}
        title={"리뷰쓰기"}
        hasCloseButton={false}
        hideModal={closeWriteReviewModal}
        className="partner-bottom-write-review-modal"
      >
        <WriteReviewBottomModalButton
          onClick={() => handleClickWriteReviewButton(props.writeReviewPageUrl)}
          imageUrl={WriteReviewImage}
          title="웨딩북 리뷰 쓰기"
          description="사진을 첨부해서 리뷰를 작성해보세요."
        />
        <WriteReviewBottomModalButton
          onClick={() => handleClickWriteReviewButton(props.writeBlogReviewPageUrl)}
          imageUrl={WriteNaverReviewImage}
          title="네이버 블로그 리뷰 쓰기"
          description="내 블로그에 작성한 후기 URL을 등록해보세요."
        />
      </BottomFixedModal>
    </>
  );
}

export function WriteReviewBottomModalButton(props: {
  onClick: () => void;
  imageUrl: string;
  title: string;
  description: string;
}) {
  return (
    <button onClick={props.onClick} className="partner-bottom-modal-write-review-btn">
      <img alt="" src={props.imageUrl} />
      <div className="text-box">
        <h4 className="title">{props.title}</h4>
        <p className="description">{props.description}</p>
      </div>
    </button>
  );
}
